import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store/src/models';
import { UserSettingsActions } from 'app/modules/main/store/user-settings/user-settings.actions';
import { UserSettingsState } from 'app/modules/main/store/user-settings/user-settings.state';

export class UserSettingsReducer {

  private static readonly initialState: UserSettingsState = { userSettingsLoaded: false };
  private static readonly failedState: UserSettingsState = { userSettingsLoaded: true };

  private static readonly onUserSettingsLoaded = on(
    UserSettingsActions.userSettingsLoaded,
    (state: UserSettingsState, { userSettings }) =>
      ({
        userSettings,
        userSettingsLoaded: true,
      })
  );

  private static readonly onUserSettingsLoadFailed = on(
    UserSettingsActions.userSettingsLoadFailed,
    (_state: UserSettingsState) => UserSettingsReducer.failedState,
  );

  static reducer(): ActionReducer<UserSettingsState> {

    return <ActionReducer<UserSettingsState>>createReducer(
      UserSettingsReducer.initialState,
      UserSettingsReducer.onUserSettingsLoaded,
      UserSettingsReducer.onUserSettingsLoadFailed,
    );
  }

}
